export default "__VITE_ASSET__CpWJMCSP__"